import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";


@Injectable({
    providedIn: 'root'
})
export class ApiProvider {
    private baseUrl: string = environment.apiUrl;
    
    constructor(protected http: HttpClient) {
    }

    getApiUrlCall(endUrl) {
        return this.baseUrl + endUrl;
    }
}
